import { Api } from '../../typings/api';

enum DriveItemListOrigin {
	Folder = 'folder',
	Selection = 'selection',
	New = 'new',
	Search = 'search',
	Assortment = 'assortment',
	Downloads = 'downloads',
}

enum TagMarkers {
	Start = 'tags[',
	End = ']',
}

interface NavigationDirectoryItemData {
	label: string;
	type: Api.DriveItemType.Directory;
	origin: DriveItemListOrigin;
	image?: string;
}

interface NavigationItemLinkData {
	label: string;
	type: Api.DriveItemType.ExternalLink;
	url: string;
	image?: string;
}

const myDocumentsNavItems: NavigationItemData[] = [
	{
		label: 'downloads',
		type: Api.DriveItemType.Directory,
		origin: DriveItemListOrigin.Downloads
	},
	{
		label: 'new',
		type: Api.DriveItemType.Directory,
		origin: DriveItemListOrigin.New
	}
];

type NavigationItemData = NavigationDirectoryItemData | NavigationItemLinkData;

export {
	DriveItemListOrigin,
	myDocumentsNavItems,
	NavigationItemData,
	TagMarkers
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/constants.ts